import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import OwlCarousel from 'react-owl-carousel';
import StarRatingComponent from 'react-star-rating-component';
import * as Api from 'api';
import { hasPermission } from 'actions';
import { parsePhone } from 'utils';
import moment from 'moment';



class PlaceDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      place : this.props.place,
      loading_maps: true,
    };
    this.updatePlace = this.updatePlace.bind(this);
    this.mounted = false;
  }
  componentWillMount() {
    this.mounted = true;
    this.updatePlace();
  }
  componentWillUpdate(nextProps, nextState) {
    if(this.state.place.place_id != nextProps.place.place_id) {
      this.updatePlace();
    }
  }
  updatePlace() {
    if(this.props.place) {

      const service = new this.props.maps.places.PlacesService(this.props.map);
      service.getDetails({
        placeId : this.props.place.place_id
      }, (place, status) => {
        if(status === this.props.maps.places.PlacesServiceStatus.OK) {
          if(this.mounted) {
            this.setState({place});
            if(this.props.onUpdatePlace)
              this.props.onUpdatePlace(place);
          }
        }
      })
    }
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    const {place} = this.state;

    return (
      <section className="animated fadeInDown">
        <div className="">
          <OwlCarousel slideSpeed={300} singleItem autoPlay>
            {place.photos? place.photos.map(photo => {
              const url = photo.getUrl({maxWidth : 500, maxHeight: 500});
              return <div style={{maxHeight : "150px"}}><img alt="" src={url} /></div>
            }) : () => {return <div></div>}}
          </OwlCarousel>


            <h4 className="text-weight-semibold mt-none">{place.name}</h4>
            {place.rating? <StarRatingComponent
                          editing={false}
                          name='rating'
                          starCount={5}
                          value={place.rating}
                        /> : ''}
            <h4 className="text-muted">Google Place Details</h4>
            <hr className="dotted short" />
            <ul className="list-unstyled">
              {place.formatted_phone_number ? <li><i className="fa fa-phone"></i> <span className="text-weight-bold">Phone: </span> {parsePhone(place.formatted_phone_number)}</li> : ''}
              <li><i className="fa fa-home"></i> <span className="text-weight-bold">Address: </span> {place.formatted_address}</li>
              <li><i className="fa fa-globe"></i> <a href={place.website} target='_blank'><span className="text-weight-bold">Website</span> </a></li>
              <li><i className="fa fa-map"></i> <a href={place.url} target='_blank'><span className="text-weight-bold">View on Google Maps</span> </a></li>
            </ul>
            {place.opening_hours && place.opening_hours.weekday_text ? (
              <div>
                <h4 className="text-muted">Hours</h4>
                <hr className="dotted short" />
                <ul className="well well-sm info list-unstyled">
                  {place.opening_hours.weekday_text.map(text => <li>{text}</li>)}
                </ul>
              </div>
            ) : ''}
            {this.props.children}
        </div>
        {this.props.hasPermission('/Account Management/Clients/Create/') ? (
          <div className="btn-group mt-sm">
            <a className="btn btn-dark" onClick={event => {
              event.preventDefault();
              this.props.onCreateClient(event);
            }} href="#"><i className="fa fa-plus mr-xs"></i> Create Lead</a>
            {place.formatted_phone_number ? <a className="btn btn-dark" href={`tel:${place.formatted_phone_number ? place.formatted_phone_number.replace('(','').replace(')','').replace(' ','').replace('-','') : ''}`}><i className="fa fa-phone mr-xs"></i> Call</a> : ''}
          </div>
        ) : null}
      </section>
    )
  }
}

PlaceDetails.propTypes = {
  place : PropTypes.object.isRequired,
  maps : PropTypes.object.isRequired,
  map : PropTypes.object.isRequired,
  onUpdatePlace : PropTypes.func,
  onCreateClient : PropTypes.func.isRequired,
  onSelectMap : PropTypes.func.isRequired,
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, { hasPermission })(PlaceDetails);



// WEBPACK FOOTER //
// ./src/browser/components/maps/place-details.js